import { BookmarkIcon, Receipt, SlidersHorizontal } from 'lucide-react'
import { ReactNode, useEffect, useState } from 'react'

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Separator } from '@/components/ui/separator';
import {
    Sheet, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle, SheetTrigger
} from '@/components/ui/sheet';
import { FieldValues, useForm, UseFormReturn } from 'react-hook-form'
import { Form } from '@/components/ui/form'
import { useTableContext } from '@/components/new'

interface FilterItem {
  title: string
  titleIcon?: ReactNode
  filterCode: string
  component: (useFormFilter: UseFormReturn<FieldValues, any, FieldValues>) => ReactNode
  filterToDisplayNameMapper: (value: any) => string
}
export interface AdvancedFiltersList {
  filters: FilterItem[]
  onSubmit: (filters: Record<string, any>) => void
}

interface Props {
  selectedFilters: Record<string, string>
  setSelectedFilters: (selected: Record<string, string>) => void
}
export const AdvancedFilters = ({selectedFilters, setSelectedFilters}: Props) => {
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false)
  const {advancedFilterList} = useTableContext()
  const filterForm = useForm()
  const { handleSubmit, reset } = filterForm
  const onApplyFilters = (filters: Record<string, any>) => {
    const appliedFilters: Record<string, string> = {}
    Object.keys(filters).forEach((key) => {
      if (filters[key] && filters[key].length > 0) {
        const filtr = advancedFilterList!.filters.find(item => item.filterCode === key)!
        appliedFilters[filtr.title] = filtr.filterToDisplayNameMapper(filters[key])
      }
    })
    setSelectedFilters(appliedFilters)
    setIsFilterDrawerOpen(false)
  }

  return (
    <Sheet open={isFilterDrawerOpen} onOpenChange={setIsFilterDrawerOpen}>
      <SheetTrigger asChild>
        <Button
          variant="outline"
          className="gap-1.5"
          aria-label="Filtros avanzados"
        >
          <SlidersHorizontal className="h-4 w-4" />
          <span className="hidden sm:inline">Filtros avanzados</span>
          {(Object.keys(selectedFilters).length > 0) && (
            <Badge variant="secondary" className="ml-1 rounded-full px-1.5">
              {Object.keys(selectedFilters).length}
            </Badge>
          )}
        </Button>
      </SheetTrigger>
        <SheetContent className="sm:max-w-md">
          <SheetHeader>
            <SheetTitle>Filtros avanzados</SheetTitle>
            <SheetDescription>
              Configura los filtros para encontrar exactamente lo que buscas.
            </SheetDescription>
          </SheetHeader>
          <Form {...filterForm}>

          <ScrollArea className="h-[calc(100vh-180px)] pr-4">
            {advancedFilterList?.filters.map((filter) => {
              return (
                <div className="flex flex-col space-y-6 py-6">
                  <div className="flex items-center space-x-2">
                    <h3 className="text-sm font-medium">
                      {filter.title || 'Misceláneos'}
                    </h3>
                    {filter?.titleIcon && filter.titleIcon}
                  </div>
                  {filter.component(filterForm)}
                  <Separator />
                </div>
              )
            })}
          </ScrollArea>

          <SheetFooter className="flex-row justify-between gap-2 sm:justify-between">
            <Button
              variant="outline"
              onClick={() => {
                reset()
                setSelectedFilters({})
                advancedFilterList!.onSubmit({})
                setIsFilterDrawerOpen(false)
              }}
              className="flex-1"
            >
              Limpiar
            </Button>
            <Button onClick={handleSubmit((filters) => {
              advancedFilterList!.onSubmit(filters);
              onApplyFilters(filters);
            })}
                    className="flex-1">
              Aplicar
            </Button>
          </SheetFooter>
          </Form>

        </SheetContent>

    </Sheet>
  )
}
